import React from 'react'

const SocialLink = ({link, classObj, icon}) => {

      if(link.length === 0) return 

      return (
            <div className="btn_social__media flex">
                  <div className={`social_icon ${classObj}`}>{icon}</div>
                  <a href={link} target="_blank" rel="noreferrer"><span>{classObj}</span></a>
            </div>
      )
}

export default SocialLink
